import { render } from "./NewShareForm.vue?vue&type=template&id=7bb00c8b&scoped=true"
import script from "./NewShareForm.vue?vue&type=script&lang=js"
export * from "./NewShareForm.vue?vue&type=script&lang=js"

import "./NewShareForm.vue?vue&type=style&index=0&id=7bb00c8b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb00c8b"]])

export default __exports__